import { Td, Text, Tr } from '@chakra-ui/react';
import { FC } from 'react';

const PeCompanyFinanceHistoryTableRow: FC<PeCompanyInvestmentItem> = ({
  date,
  topInvestors,
  type,
  income,
}) => {
  return (
    <Tr>
      <Td>
        <Text>{date}</Text>
      </Td>
      <Td>
        <Text>{type}</Text>
      </Td>
      <Td>
        <Text>{income}</Text>
      </Td>
      <Td>
        <Text>{topInvestors}</Text>
      </Td>
    </Tr>
  );
};

export default PeCompanyFinanceHistoryTableRow;
